import React from 'react';
import { Link } from 'react-router-dom';
import { tools } from '../toolRegistry';
import Card from './ui/Card';
import Badge from './ui/Badge';

const Home = () => {
  return (
    <div className="home-page">
      <section className="home-hero">
        <h1>Dev tools</h1>
      </section>

      <div className="tool-grid">
        {tools.map((tool) => (
          <Card key={tool.slug} className="tool-card">
            <div className="tool-card__meta">
              <span>{tool.category}</span>
              <Badge tone={tool.status === 'available' ? 'success' : 'default'}>
                {tool.status === 'available' ? 'Live' : 'Em breve'}
              </Badge>
            </div>
            <h3>{tool.name}</h3>
            <p>{tool.description}</p>
            {tool.status === 'available' ? (
              <Link to={`/${tool.slug}`} className="tool-card__link">
                Abrir →
              </Link>
            ) : (
              <span className="tool-card__link tool-card__link--disabled">Em breve</span>
            )}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Home;
